import { isValidElement } from 'react';

import Button from 'components/shared/Button/Button';

const renderButton = ({ config, defaultText, defaultVariant, defaultOnClick, defaultDataQa }) => {
  if (isValidElement(config)) return config;

  if (config && typeof config === 'object') {
    return (
      <Button
        text={config.text || defaultText}
        onClick={config.onClick || defaultOnClick}
        variant={config.variant || defaultVariant}
        color={config.color}
        style={config.style}
        size={config.size || 'small'}
        isLoading={config.isLoading}
        isDisabled={config.isDisabled}
        data-qa={config.dataQa || defaultDataQa}
        {...config.buttonProps}
      />
    );
  }

  return null;
};

export default renderButton;
